import { render, staticRenderFns } from "./EmptyListImageInbox.vue?vue&type=template&id=55a19296&scoped=true"
var script = {}
import style0 from "./EmptyListImageInbox.vue?vue&type=style&index=0&id=55a19296&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a19296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a19296')) {
      api.createRecord('55a19296', component.options)
    } else {
      api.reload('55a19296', component.options)
    }
    module.hot.accept("./EmptyListImageInbox.vue?vue&type=template&id=55a19296&scoped=true", function () {
      api.rerender('55a19296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/emptyListImages/EmptyListImageInbox.vue"
export default component.exports